import { render, staticRenderFns } from "./DialogConsentGroupEmailCreate.vue?vue&type=template&id=385aa07c&scoped=true&"
import script from "./DialogConsentGroupEmailCreate.vue?vue&type=script&lang=js&"
export * from "./DialogConsentGroupEmailCreate.vue?vue&type=script&lang=js&"
import style0 from "./DialogConsentGroupEmailCreate.vue?vue&type=style&index=0&id=385aa07c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385aa07c",
  null
  
)

export default component.exports